import * as React from 'react';
import PropTypes from 'prop-types';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import pvBottle from './../../Styles/Logos/pvBottle.png';
import Image from "react-bootstrap/Image";
import { useNavigate } from 'react-router-dom';



function Header(props) {
  const { sections, title } = props;

  const navigate = useNavigate();
  function handleExit() {
      props.updateTab('/Services');
      navigate('/Services');
      
  }

  return (
    <React.Fragment>
      <Toolbar sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Image src={pvBottle} style={{height:'3vh', paddingRight:'1vw'}}></Image>
        <Typography
          component="h2"
          variant="h5"
          color="secondary"
          align="center"
          noWrap
          sx={{ flex: 1 }}
        >
          {title}
        </Typography>
        <IconButton>
          <ShoppingCartIcon />
        </IconButton>
        <Button variant="contained" size="small" onClick={()=>handleExit()}>
          Exit Demo
        </Button>
      </Toolbar>
      <Toolbar
        component="nav"
        variant="dense"
        sx={{ justifyContent: 'center', overflowX: 'auto' }}
      >
        {sections.map((section) => (
          <Link
            color="inherit"
            noWrap
            key={section.title}
            variant="body2"
            href={section.url}
            sx={{ p: 1, flexShrink: 0 }}
          >
            <Button>{section.title}</Button>
            
          </Link>
        ))}
      </Toolbar>
    </React.Fragment>
  );
}

Header.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      tab: PropTypes.string,
      updateTab:PropTypes.func,
    }),
  ).isRequired,
  title: PropTypes.string.isRequired,
};

export default Header;